import { render, staticRenderFns } from "./TournamentEditGame.vue?vue&type=template&id=1ec97378"
import script from "./TournamentEditGame.vue?vue&type=script&lang=js"
export * from "./TournamentEditGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports